const stickyCart = document.querySelector('.sticky-cart-wrapper');

if (stickyCart) {
  // Function to handle scroll and visibility of the sticky cart
  function onScroll() {
    // Check if the user is scrolling
    if (window.scrollY > 0) {  // If there's any scroll position (i.e., scroll has started)
      setTimeout(() => {
        stickyCart.setAttribute('animate', '');  // Add the 'animate' attribute to show the sticky cart
        console.log('Animate attribute added on scroll');
      }, 50);
    } else {
      setTimeout(() => {
        // stickyCart.removeAttribute('animate');  // Remove the 'animate' attribute to hide the sticky cart
        console.log('Animate attribute removed on scroll');
      }, 50);
    }
  }

  // Run the function once on page load to show the sticky cart
  window.addEventListener('load', () => {
    stickyCart.setAttribute('animate', '');  // Add the 'animate' attribute on page load
    console.log('Animate attribute added on page load');
  });

  // Add scroll event listener to handle scroll events
  window.addEventListener('scroll', onScroll);
}
